<template>
  <div class="teacher-card">
    <Card
      :padding="0"
      style="width: 100%; border-radius: 8px; overflow: hidden"
    >
      <Row>
        <Col flex="1">
          <Image v-if="image" :src="image" :height="imageHeight" />
          <slot></slot>
        </Col>
      </Row>
    </Card>
  </div>
</template>

<script>
export default {
  props: {
    image: {
      type: String,
      default: "",
    },
    imageHeight: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.teacher-card {
  cursor: pointer;
}
</style>
